import i18n from '../../managers/i18n'

i18n.register(
  'zh-Hans',
  {
    step: '步骤 {index}'
  },
  {
    ns: 'steps'
  }
)
